<template>
  <ProductPage :product="product" />
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import ProductPage from '@/components/ProductPage.vue'
import { assertProductConfig } from '@/views/product/productConfigValidation'
import { translateSpecTabs } from '@/views/product/productSpecTranslation'
import { pboxProducts } from './pboxProducts'

const { t, tm } = useI18n()

const props = defineProps({
  productKey: {
    type: String,
    required: true
  }
})

const baseProduct = computed(() => {
  const productConfig = pboxProducts[props.productKey]
  assertProductConfig(productConfig, props.productKey)

  return productConfig
})

const product = computed(() => {
  const content = tm(baseProduct.value.i18nKey)
  const commonScenarios = tm('AutomotiveGnssProducts.gnm13.scenarios')

  return {
    ...content,
    ...baseProduct.value,
    descriptionTags: baseProduct.value.descriptionTags.map((tag, index) => ({
      ...tag,
      label: content.descriptionTags?.[index] || tag.key
    })),
    featureTags: baseProduct.value.featureTags.map((tag, index) => ({
      ...tag,
      label: content.featureTags?.[index] || tag.key
    })),
    specTabs: content.specTabs || translateSpecTabs(baseProduct.value.specTabs, t, tm),
    scenarios: baseProduct.value.scenarios.map((scenario) => ({
      ...scenario,
      ...(content.scenarios?.[scenario.key] || {}),
      ...(commonScenarios?.[scenario.key] || {})
    }))
  }
})
</script>
